// extracted by mini-css-extract-plugin
export default {"section":"Section__section___rRH9z"};